<template>
    <div v-if="leases.selectedLease">
        <div class="p-6 flex flex-col">
            <div v-if="showUnallocatedError" class="mb-3 alert red">Unallocated square footage cannot be less than zero</div>
            <div class="grid grid-cols-2 gap-6">
                <div class="p-6 site-title-bar rounded">
                    <p class="flex flex-col items-center text-white space-y-2">
                        <span class="text-4xl font-bold">{{ leases.selectedLease.total_square_feet | number }}</span>
                        <span class="text-lg">Total Square Footage</span>
                    </p>
                </div>

                <div class="p-6 site-title-bar rounded">
                    <p class="flex flex-col items-center text-white space-y-2">
                        <span class="text-4xl font-bold">{{ unallocatedSquareFootage | number }}</span>
                        <span class="text-lg">Unallocated Square Footage</span>
                    </p>
                </div>
            </div>

            <div class="mt-5 grid gap-6" :class="fromReatlas ? 'grid-cols-1' : 'grid-cols-3'">
                <div class="p-5 flex flex-col site-title-bar rounded-md space-y-5">
                    <!-- <p class="flex items-center justify-between text-white font-semibold">
                        <span>Office Space</span>
                        <span class="font-semibold">{{ leases.selectedLease.office_percentage }}%</span>
                    </p> -->
                    <p class="flex items-center justify-between text-white font-semibold">
                        <span class="flex items-center space-x-1">
                            <span>Office Space</span>
                            <InfoIcon identifier="sites-usage-officespace" />
                        </span>
                        <span class="font-semibold">{{ leases.selectedLease.office_percentage }}%</span>
                    </p>
                    <input @change="save" v-model.number="leases.selectedLease.office_percentage" type="range" min="0" max="100" step="5" class="mt-3 range-blue">
                    <div class="flex items-center justify-center text-white">
                        <p class="flex items-center space-x-1">
                            <span class="text-lg font-semibold">{{ calculateSquareFootage(leases.selectedLease.office_percentage) | number }}</span>
                            <span class="ml-px font-variant-all-small-caps">Square Feet</span>
                        </p>
                    </div>
                </div>
                <div v-if="['Industrial', 'Flex'].includes(sites.selectedSite.building.type.type)" class="p-5 flex flex-col bg-gradient-to-b from-green-500 to-green-600 rounded-md space-y-5">
                    <!-- <p class="flex items-center justify-between text-white font-semibold">
                        <span class="text-green-50">Industrial Space</span>
                        <span class="font-semibold">{{ leases.selectedLease.industrial_percentage }}%</span>
                    </p> -->
                    <p class="flex items-center justify-between text-white font-semibold">
                        <span class="flex items-center space-x-1 text-green-50">
                            <span>Industrial Space</span>
                            <InfoIcon identifier="sites-usage-industrialspace" />
                        </span>
                        <span class="font-semibold">{{ leases.selectedLease.industrial_percentage }}%</span>
                    </p>
                    <input @change="save" v-model.number="leases.selectedLease.industrial_percentage" type="range" min="0" max="100" step="5" class="mt-3 range-green">
                    <div class="flex items-center justify-center text-white">
                        <p class="flex items-center space-x-1">
                            <span class="text-lg font-semibold">{{ calculateSquareFootage(leases.selectedLease.industrial_percentage) | number }}</span>
                            <span class="ml-px text-green-50 font-variant-all-small-caps">Square Feet</span>
                        </p>
                    </div>
                </div>
                <div v-if="['Industrial', 'Flex'].includes(sites.selectedSite.building.type.type)" class="p-5 flex flex-col bg-gradient-to-b from-green-500 to-green-600 rounded-md space-y-5">
                    <!-- <p class="flex items-center justify-between text-white font-semibold">
                        <span class="text-green-50">Manufacturing Space</span>
                        <span class="font-semibold">{{ leases.selectedLease.manufacturing_percentage }}%</span>
                    </p> -->
                    <p class="flex items-center justify-between text-white font-semibold">
                        <span class="flex items-center space-x-1 text-green-50">
                            <span>Manufacturing Space</span>
                            <InfoIcon identifier="sites-usage-manufacturingspace" />
                        </span>
                        <span class="font-semibold">{{ leases.selectedLease.manufacturing_percentage }}%</span>
                    </p>
                    <input @change="save" v-model.number="leases.selectedLease.manufacturing_percentage" type="range" min="0" max="100" step="5" class="mt-3 range-green">
                    <div class="flex items-center justify-center text-white">
                        <p class="flex items-center space-x-1">
                            <span class="text-lg font-semibold">{{ calculateSquareFootage(leases.selectedLease.manufacturing_percentage) | number }}</span>
                            <span class="ml-px text-green-50 font-variant-all-small-caps">Square Feet</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState } from 'vuex';

    export default {
        components: {
        },

        props: {
        	formErrors: {
        		type: [String, Object],
        		required: false
        	},

            fromReatlas: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                loading: false,
                showUnallocatedError: false,

                valueType: {
                    value2date: (value) => {
                        return value ? moment(value, 'YYYY-MM-DD').toDate() : null
                    },
                    date2value: (date) => {
                        return date ? moment(date).format('YYYY-MM-DD') : null
                    }
                }                 
            }
        },

        computed: {
            ...mapState(['leases']),
            ...mapState(['sites']),

            unallocatedSquareFootage() {
                if (this.leases.selectedLease.office_percentage + this.leases.selectedLease.industrial_percentage + this.leases.selectedLease.manufacturing_percentage == 100) {
                    return 0;
                }

                var unallocatedSquareFootage = this.leases.selectedLease.total_square_feet - this.calculateSquareFootage(this.leases.selectedLease.office_percentage) - this.calculateSquareFootage(this.leases.selectedLease.industrial_percentage) - this.calculateSquareFootage(this.leases.selectedLease.manufacturing_percentage);

                return (isNaN(unallocatedSquareFootage) ? 0 : unallocatedSquareFootage);
            },

            isValidAllocation() {
                if (this.leases.selectedLease.office_percentage + this.leases.selectedLease.industrial_percentage + this.leases.selectedLease.manufacturing_percentage <= 100) {
                    return true;
                }

                return false;
            },

            errors() {
            	return this.formErrors;
            }
        },

        methods: {
            calculateSquareFootage(percentage) {
                var sqFt = parseInt(this.leases.selectedLease.total_square_feet * (percentage / 100));

                return (isNaN(sqFt) ? 0 : sqFt);;
            },

            save() {
                this.showUnallocatedError = false;
                
                if (this.unallocatedSquareFootage < 0) {
                    this.showUnallocatedError = true;

                    return;
                }

                this.loading = true;
                
                axios.patch('/leases/' + this.leases.selectedLease.id, this.leases.selectedLease).then((response) => {
                    this.leases.selectedLease = response.data.lease || this.leases.selectedLease;

                    this.$emit('leaseSaved', response.data.lease ? response.data.lease.id : this.selectedLeaseId);
                    this.$emit('updateUtilization', response.data.lease.site);

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });
                }).catch((error) => {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response.data.message
                    });
                }).finally(() => {
                    this.loading = false;
                });
            },
        }
    }
</script>